import { forwardRef } from 'react';
import Slide from '@mui/material/Slide';
import Dialog from '@mui/material/Dialog';
import SECDialogBar from './SECDialogBar';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="right" ref={ref} {...props} />;
});

function SECDetail({ open=false, createEnabled=false, handleClose, handleSave, title, openBackdrop = false, showSave = true, children }) {
    return (
        <Dialog
            fullScreen
            open={open || createEnabled}
            onClose={handleClose}
            TransitionComponent={Transition}
        >
            <SECDialogBar title={title} handleClose={handleClose} handleSave={handleSave} showSave={showSave} />

            {children}

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>            

        </Dialog>
    );
}

export default SECDetail;